import _ from "lodash";

import {
  Component,
} from "react";

import helpApi, {
  articleToAnchor,
} from "Apis/help-api";
import {
  createDetailEditorConnector,
} from "CommonComponents/page-factories";
import {
  ifValidEntity,
} from "CommonState/uiconfig";
import {
  ANTRAGSTELLERMODUS,
} from "App/constants";


const prepareHilfe = entity => {
  const preparedEntity = _.clone(entity);
  const modushilfen = preparedEntity.modushilfen || [];
  _.forEach(ANTRAGSTELLERMODUS, (value, key) => {
    preparedEntity["hi_titel_" + key] = modushilfen.find(mh => mh.him_astmodus == key)?.him_titel || "";
    preparedEntity["hi_text_" + key] = modushilfen.find(mh => mh.him_astmodus == key)?.him_text || "";
  });

  return preparedEntity;
};

const beforeSaveHilfe = entity => {
  /*
   * //Validierungen
   *if (!entity.n_zim_konto && !entity.na_id) {
   *  let e = new Error()
   *  e.response = {
   *    nachricht: 'Es ist ein Fehler aufgetreten',
   *    details: [{ attribut: 'n_zim_konto', nachricht: "Bitte geben Sie einen ZIM-Account an." }]
   *  };
   *  throw e;
   *}
   */

  const modushilfen = [];
  _.forEach(ANTRAGSTELLERMODUS, (value, key) => {
    modushilfen.push({
      him_astmodus: key,
      him_titel: entity["hi_titel_" + key],
      him_text: entity["hi_text_" + key],
    });
  });
  entity.modushilfen = modushilfen;
  return entity;
};

const makeDetailEditor = schema => createDetailEditorConnector({
  api: helpApi,
  bordered: true,
  schema,
  prepareEntity: prepareHilfe,
  beforeSave: beforeSaveHilfe,
  locationAfterSave: (id, hi) => `/hilfe#${ articleToAnchor(hi) || id }`,
});

const HilfeEditor = makeDetailEditor();
HilfeEditor.displayName = "RegularEditor";
@helpApi.current
@ifValidEntity("currentHilfe")
export default class HelpEditPage extends Component {
  render() {
    return <HilfeEditor {...this.props} />;
  }
}
